import React from 'react';

const EnquiryModal = ({ isOpen, onClose, children }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center px-4">
      <div className="bg-white rounded-xl max-w-2xl w-full py-8 px-8 relative shadow-lg overflow-y-auto max-h-[90vh]">
        <button
          onClick={onClose}
          className="absolute top-1 right-4 text-black text-4xl font-normal"
        >
          &times;
        </button>
        <h2 className="lg:text-4xl text-2xl mb-4 text-center uppercase font-medium text-[#9A6E3A]">Enquire Now</h2>
        {children}
      </div>
    </div>
  );
};

export default EnquiryModal;
